import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  requestResequenceHistory: `${NAMESPACE}_REQUEST_RESEQUENCE_HISTORY`,
  requestResequenceHistorySuccess: `${NAMESPACE}_REQUEST_RESEQUENCE_HISTORY_SUCCESS`,
  switchToggle: `${NAMESPACE}_SWITCH_TOGGLE`,
};

export const actionCreators = {
  requestResequenceHistory: payload => ({ type: actions.requestResequenceHistory, payload }),
  requestResequenceHistorySuccess: payload => ({ type: actions.requestResequenceHistorySuccess, payload }),
  switchToggle: payload => ({ type: actions.switchToggle, payload })
};

export default {
  actions,
  actionCreators,
};
